<template>
  <section class="compose-content">
    <div v-show="!clickedItem">
      <b-form inline>
        <b-button class="no-border" @click="getItems"
          ><i class="fal fa-sync"></i
        ></b-button>

        <b-form-input trim
          value=""
          :placeholder="$t('SEARCH')"
          @keydown.enter.prevent
          class="searchText newline-mobile"
        ></b-form-input>
      </b-form>

      <b-table
        class="mt-2"
        striped
        hover
        :items="items"
        :fields="fields"
      >
        <template v-slot:cell(id)="data">
          <b-button
            variant="dark"
            size="sm"
            @click="selectedAddress(data.item.data)"
            >{{ $t("CHOOSE") }}</b-button
          >
          <b-button
            variant="secondary"
            size="sm"
            class="no-border"
            @click="showMe(data.item)"
            >{{ $t("MORE_INFORMATION") }}</b-button
          >
        </template>
      </b-table>

      <b-row>
        <b-col cols="12" md="6">
          <div>
            <b-form inline>
              <b-button
                v-if="selected.length != 0"
                @click="removeRecipients"
                variant="danger"
                >{{ $t("REMOVE_SELECTED") }}</b-button
              >
            </b-form>
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <b-pagination
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="limit"
            align="center"
            @input="getItems"
            pills
          >
          </b-pagination>
        </b-col>
      </b-row>

      <b-button @click="cancelBtn">{{ $t("BACK") }}</b-button>
      <b-button @click="saveIdentifier = true" variant="primary">{{ $t("SDK.SAVE_WITH_IDENTIFIER") }}</b-button>
    </div>



    <b-modal
      id="add-sdk-with-identiier"
      :dialog-class="teams.theme"
      v-model="saveIdentifier"
      hide-header
      @cancel="cancelSave"
      @ok="saveAddress"
      :ok-disabled="!to_sdk"
      centered
      :cancel-title="$t('CANCEL')"
      :ok-title="$t('ADD')"
    >
      <b-form-input trim v-model="identifier" :placeholder="$t('SDK.IDENTIFIER')"></b-form-input>
      
      <b-button class="mt-2" @click="searchReplyIdentifier" variant="primary">{{ $t("FETCH_INFORMATION") }}</b-button>
  
      <div v-if="to_sdk" class="mt-2 mb-2">
        <div class="sdk-recipient">
          {{ to_sdk.attributes.name }}
          <div
            v-if="to_sdk.attributes.name != to_sdk.attributes.description"
          >
            <small>{{ to_sdk.attributes.description }}</small>
          </div>
        </div>
      </div>
    </b-modal>



    <div v-if="clickedItem">
      <SDKInformation
        :item="clickedItem"        
        :functionbox_uuid="functionbox_uuid"
        @setItem="setItem"
        @selectedAddress="selectedAddress"
        @removedAddress="removedAddress"
        @backBtn="backBtn"
      ></SDKInformation>
    </div>
  </section>
</template>
<script>
import SDKInformation from "@/components/Input/SDK/SdkInformation_4_2";
export default {
  components: {
    SDKInformation
  },
  props: ["functionbox_uuid"],
  data() {
    return {
      fields: [
        {
          key: "data.attributes.name",
          label: "",
          class: "hidden-not-mobile",
          thClass: "w-150",
        },
        {
          key: "data.attributes.description",
          label: "",
          class: "hidden-not-mobile",
          thClass: "w-350",
        },
        {
          key: "Id",
          label: "",
          class: "text-break clickable hidden-mobile",
          thClass: "w-300",
        },
      ],
      to_sdk: null,
      saveIdentifier: false,
      identifier: "",
      identifierValid: false,
      filterLimit: 10,
      currentFilterPage: 1,
      tabindex: 0,
      selected: [],
      currentPage: 1,
      limit: 6,
      loading: false,
      items: [],
      clickedItem: null,
    };
  },
  methods: {
    async clearModal(){
      this.saveIdentifier = false;
      this.identifier = "";
      this.to_sdk = null;
    },    
    async saveAddress() {
      let self = this;
      let AddSdkSefosAddressDTO = {
        functionbox_uuid: this.functionbox_uuid,
        sdk_identifier: this.to_sdk.attributes.identifier,
      };
      await this.$http
        .post(this.user.hostname + "/sdk/address/add", AddSdkSefosAddressDTO)
        .then(function () {
          self.$noty.info(self.$t("SAVED"));
          self.getItems();
          self.clearModal();
          self.loading = false;
        })
        .catch(function (error) {
          self.loading = false;
          if(error.toString() == "Error: fail_4_4") return;
          self.$noty.error(self.$t(error.response));
        });
    },
    cancelSave(){
      this.clearModal();
    },
    async searchReplyIdentifier() {
      let self = this;
      let SdkIdentifierDTO = {
        functionbox_uuid: self.functionbox_uuid,
        identifier: this.identifier
      };
      self.loading = true;
      await this.$http
        .post(this.user.hostname + "/sdk/address/identifier", SdkIdentifierDTO)
        .then(function(result) {
          self.to_sdk = result.data;
        })
        .catch(function(error) {
          self.loading = false;
          if(error.toString() == "Error: fail_4_4") return;
          if (error.response != undefined) {
            self.$noty.error(self.$t(error.response.data));
          }
        });
    },
    setItem(item){
      this.clickedItem = item;
    },
    removedAddress(){
      this.getItems();
    },
    backBtn(){
      this.clickedItem = null;
    },
    showMe(item)
    {
      this.clickedItem = item;
    },
    selectedAddress(item) {
      this.$emit('selectedAddress', item);
    },
    async removeRecipients() {
      let self = this;
      this.$bvModal
        .msgBoxConfirm(this.$t("ARE_YOU_SURE"), {
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("YES"),
          cancelTitle: this.$t("NO"),
          dialogClass: this.teams.theme,
          bodyClass: "messagebox",
          footerClass: "p-2  text-center messagebox",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async function(value) {
          if (value) {
            let RemoveSdkSefosFilterDTO = {
              id_list: self.selected,
              functionbox_uuid: self.functionbox_uuid,
            };
            await self.$http
              .post(
                self.user.hostname + "/sdk/address/remove",
                RemoveSdkSefosFilterDTO
              )
              .then(function() {
                self.$noty.info(self.$t("REMOVED"));
                self.getSavedFilters();
                self.loading = false;
              })
              .catch(function(error) {
                self.loading = false;
                if(error.toString() == "Error: fail_4_4") return;
                self.$noty.error(self.$t(error.response));
              });
          }
        })
        .catch(function() {});
    },
    cancelBtn() {
      this.$emit("cancel");
    },
    async getItems() {
      let self = this;
      self.loading = true;
      await this.$http
        .get(
          this.user.hostname + "/sdk/address/" + this.functionbox_uuid
        )
        .then(function(result) {
          self.items = result.data;
          self.loading = false;
        })
        .catch(function() {
          self.loading = false;
        });
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  watch: {},
  mounted() {
    this.getItems();
  },
};
</script>
<style></style>
